import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
import { GamePlayerContext, LocalPlayerContext, NotificationContext } from '../../context/game-context';
import { InputGroup, Spinner } from 'react-bootstrap';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useAuthBasicService } from '../../../blockhain/provider/initiate.provider';
import { useDispatch, useSelector } from 'react-redux';
import { RequestForgotPasswordLink, ResetState } from '@redux/actions/auth/forgot-password.actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const AccountForgotPassword = ({ setCurrentStep }) => {
    const [isSubmitting, setSubmitting] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');

    const onRequest = useSelector((state) => state.ForgotPassword.onRequest)
    const forgotPasswordState = useSelector((state) => state.ForgotPassword.forgotPasswordState)
    const userData = useSelector((state) => state.ForgotPassword.data)
    const dispatch = useDispatch();

    const handleSubmit = async (values, actions) => {
        const checkActivation = await RequestForgotPasswordLink(values.email);

        dispatch(checkActivation)
    };
    
    const resetState = async () => {
        const checkActivation = await ResetState();

        dispatch(checkActivation)
    };

    const validationSchema = Yup.object().shape({
        email: Yup.string().email().required('Email is required'),
    });

    const initialValues = {
        email: '',
    };

    console.log(forgotPasswordState);

    return (
        <>
            <h5 className='my-3 fw-bold'>
                Kami akan mengirimkan link reset
                kata sandi ke E-mail anda.
            </h5>
            <hr />
            <div className='row p-0 text-start mb-3'>
                {errorMsg != '' && <Alert variant="danger">{errorMsg}</Alert>}
                {successMsg != '' && <Alert variant="success">{successMsg}</Alert>}
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ setFieldValue, errors, touched }) => (
                        <>
                            {onRequest && <>

                                <p className='text-center mt-2'><Spinner size='md' /><br />Sedang Memuat, Mohon Tunggu ...</p>
                            </>}
                            {(!onRequest && forgotPasswordState != 'request_success') && <Form className={`p-0 ${errors && touched && 'needs-validated'}`}>

                                <div className='row mb-3'>
                                    <Field type="email" name="email" placeholder="Email" className={`form-control ${(touched.email && errors.email) && 'is-invalid'}`} />

                                    {errors.email && touched.email && (
                                        <div className="invalid-feedback p-0" style={{ display: 'block' }}>{errors.email}</div>
                                    )}
                                </div>

                                <Button variant="primary" type="submit" disabled={isSubmitting} className={"w-100"}>
                                    Kirim Reset Link
                                </Button>
                            </Form>}
                            {(!onRequest && forgotPasswordState == 'request_success') &&
                                <div className='text-center'>
                                    <FontAwesomeIcon icon="far fa-check-circle" className="text-primary mb-4" style={{ fontSize: '60px' }} />
                                    <h6>Link reset kata sandi telah terkirim ke email anda</h6>
                                    <p className="mt-3">
                                        <a href='#' onClick={() => {
                                            resetState();
                                            setCurrentStep('login');
                                        }} className='btn btn-primary w-100'>Kembali ke Halaman Log In</a></p>
                                </div>
                            }
                        </>
                    )}
                </Formik>
            </div>
            {(!onRequest && forgotPasswordState != 'request_success') && <>
            <hr />
            <p className='mb-2'>Ingat password anda? klik <a className='text-primary' onClick={() => setCurrentStep('login')}>disini</a></p>
            </>}
        </>
    )
}